import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {BaseComponent} from '../../BaseComponent';

@Component({
  selector: 'app-cron-input',
  templateUrl: './cron-input.component.html',
  styleUrls: ['./cron-input.component.css']
})
export class CronInputComponent extends BaseComponent implements OnChanges {

  @Input() value: string = '0 * * * *';
  @Input() disabled: boolean = false;
  @Output() valueChange = new EventEmitter<string>();

  protected enableAdvancedCronSelection: boolean = false;

  protected readonly simpleCronSelectionOptions = [
    {label: 'REGISTRY.VIRTUAL_METRICS.TEXT.ONE_MIN',     value: '* * * * *'},
    {label: 'REGISTRY.VIRTUAL_METRICS.TEXT.FIVE_MIN',    value: '0,5,10,15,20,25,30,35,40,45,50,55 * * * *'},
    {label: 'REGISTRY.VIRTUAL_METRICS.TEXT.FIFTEEN_MIN', value: '0,15,30,45 * * * *'},
    {label: 'REGISTRY.VIRTUAL_METRICS.TEXT.ONE_HOUR',    value: '0 * * * *'},
    {label: 'REGISTRY.VIRTUAL_METRICS.TEXT.ONE_DAY',     value: '0 0 * * *'},
    {label: 'REGISTRY.VIRTUAL_METRICS.TEXT.ONE_WEEK',    value: '0 0 * * 1'},
    {label: 'REGISTRY.VIRTUAL_METRICS.TEXT.ONE_MONTH',   value: '0 0 1 * *'},
    {label: 'REGISTRY.VIRTUAL_METRICS.TEXT.ONE_YEAR',    value: '0 0 1 1 *'},
  ];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']?.isFirstChange() && this.value) {
      const isSimple = this.simpleCronSelectionOptions.some(o => o.value === this.value);
      this.enableAdvancedCronSelection = !isSimple;
    }
  }

  protected onModeToggle(advanced: boolean): void {
    if (!advanced) {
      const isSimple = this.simpleCronSelectionOptions.some(o => o.value === this.value);
      if (!isSimple) {
        this.value = this.simpleCronSelectionOptions[0].value;
        this.valueChange.emit(this.value);
      }
    }
  }

  protected onSimpleChange(value: string): void {
    this.value = value;
    this.valueChange.emit(value);
  }

  protected onAdvancedChange(cron: string): void {
    this.value = cron;
    this.valueChange.emit(cron);
  }

  protected translateSimpleCron = (option: any): string => {
    if (option) return this.translate.instant(option.label);
    return '';
  };
}
